const DEFAULT_LENGTH = 6;
const DEFAULT_CHARSET = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=';

export function randomPassword(length: number = DEFAULT_LENGTH, charset: string = DEFAULT_CHARSET) {
	const randomValues = crypto.getRandomValues(new Uint32Array(length));

	return Array.from(randomValues, (value) => charset.charAt(value % charset.length)).join('');
}
